export const translationES = {
  error: {
    401: {
      title: 'No Autorizado',
      description: 'No tienes autorización para ver esta página.',
      button: 'Volver al inicio'
    },
    'slug-must-be-unique': 'El slug debe ser único',
  },
  components: {
    menu: {
      logout: 'Cerrar sesión',
    },
    footer: {
      policyprivacy: 'Politica de privacidad',
      aboutus: 'Nosotros',
      termsofservice: 'Terminos y condiciones',
    },
    table: {
      show: 'Mostrar',
      notresults: 'Sin resultados',
    },
    navbar: {
      home: 'Inicio',
      users: 'Usuarios',
      product_enrollments: 'Inscripciones a producto',
      commison_enrollments: 'Inscripciones a cursos',
      products: 'Productos',
      products_career: 'Carrera',
      products_course: 'Curso',
      products_on_demand: 'On Demand',
      products_on_demand_b2b: 'On Demand B2B',
      productList: 'Productos',
      subjects: 'Materias / Cursos',
      modules: 'Modulos',
      courses: 'Cursos',
      myCourses: 'Mis cursos',
      students: 'Estudiantes',
      course: 'Cursada',
      courseConfig: 'Contenidos',
      paths: 'Tracks',
      subjectVersions: 'Versiones de materia',
    },
    home: {
      welcome_title: 'Bienvenidos a ',
      welcome_product_text: 'SMS',
      welcome_subtitle: 'Student Management System',
    },
    'state-icon': {
      create: 'C',
      open: 'A',
      close: 'C',
      opened: 'A',
      finaliced: 'F',
      closed: 'C',
      'create-tooltip': 'Creada',
      'open-tooltip': 'Abrir',
      'close-tooltip': 'Cerrada',
      'opened-tooltip': 'Abierta',
      'finaliced-tooltip': 'Finalizar',
      'closed-tooltip': 'Cerrar',
    },
  },
  attendance: {
    title: 'Asistencia',
    'sub-title': 'Comisión',
    attendance: 'Presentismo',
    registry: 'Registro de asistentes',
    'students-not-found': 'No se encontro el listado de estudiantes',
    'state-present': 'Presente',
    'state-late': 'Tarde',
    'state-no-registry': 'initial State',
    justify: 'justificada',
    'state-justify': 'Justificada',
    'get-attendance': 'Tomar asistencia',
    'state-absent': 'Ausente',
  },
  resources: {
    progressDisplay: {
      title: 'Visualización de progreso',
      select: 'Seleccionar una visualización de progreso',
      percent: 'Porcentaje',
      stage: 'Estado',
      percent_with_final_stage: 'Porcentaje con estado final',
    },
    users: {
      viewProfile: 'Ver perfil',
    },
    staff: {
      requires: 'Se necesitan:',
    },
    exceptionsGroups: {
      select: 'Seleccionar Feriados',
    },
    lessons: {
      create: 'Crear Clase',
      new: 'Agregar clase',
      quantity: 'Cantidad de clases',
    },
    modules: {
      create: 'Crear Módulo',
      created: 'Módulo creado',
      edit: 'Editar Módulo',
      new: 'Nuevo Módulo',
      'async-lesson-add': '+ Clase asincronica',
      'sync-lesson-add': '+ Clase sincronica',
      'async-lessons': 'Clases asincronicas',
      'sync-lesson': 'Clase sincronica',
      'sync-lesson-placeholder': 'Ingresa el nombre de la clase',
      'async-lesson-placeholder': 'Ingresa el nombre de la clase asincronica',
      plan: 'Planificación de módulos',
      'description-placeholder': 'Describe el módulo',
      'warning-courses-linked':
        'Esta versión posee cusos activas vinculadas. Cualquier cambio realizado en la misma no impacta en las comisiones activas.',
    },
    periodicities: {
      onceaweek: 'Una vez a la semana',
      everytweeks1: 'Cada 2 semanas empezando la primera semana',
      everytweeks2: 'Cada 2 semanas empezando la segunda semana',
      select: 'Seleccionar periodicidad',
    },
    products: {
      errordata: 'Error consultando datos, reintente',
      cluster: 'Cluster',
      create: 'Crear Producto',
      edit: 'Editar Producto',
      created: 'Producto creado',
      updated: 'Producto actualizado',
      updatederror: 'Ocurrió un error al actualizar el producto',
      error: 'Ocurrio un error al crear el producto',
      code: 'Codigo de producto',
      select: 'Seleccionar producto',
      'select-cluster': 'Seleccionar Cluster',
      'select-duration': 'Seleccionar Duracion',
      'select-course': 'Seleccionar Curso',
      search: 'Buscar producto',
      'list-title': 'Productos',
      'career-list-title': 'Productos de Carrera',
      'course-list-title': 'Productos de Curso',
      'on-demand-list-title': 'Productos On Demand',
      'on-demand-b2b-list-title': 'Productos On Demand B2B',
      duration: 'Duración',
      courses: 'Cursos',
      course: 'Curso',
      paths: {
        label: "Rutas",
        placeholder: "Seleccionar rutas",
      },
      path: 'Path',
      'path-placeholder': 'Seleccionar path',
      'slot-from': 'Franja horaria desde',
      'slot-to': 'Franja horaria hasta',
      'admission-type': 'Tipo de admisión',
      'admission-type-placeholder': 'seleccionar',
      'admition-process-async': 'Proceso de admisión asincrónico',
      'admition-process-404': 'Proceso de admisión 404',
      'admition-process-placeholder': 'seleccionar',
      'course-onboarding': 'Curso de onboarding en Playground',
      'course-onboarding-placeholder': 'seleccionar',
      'modal-enrollment': 'Ejecutar la matriculación',
      'enrollment-successful': 'Matriculación Exitosa',
      'enrollment-timeout': 'Matriculación en proceso, compruebe en unos minutos',
      'enrollment-fail-title': 'La matriculación no fue completada',
      'enrollment-simulation-fail-default': 'Por favor intente nuevamente mas tarde',
      'enrollment-simulation-fail-nousers': 'No existen usuarios sin matricular en este producto',
      'simulation-successful-title': 'Simulación Exitosa',
      'simulation-successful-content': 'El archivo se ha descargado en su equipo',
      'simulation-fail-title': 'La simulación no fue completada',
      'simulation-button': 'Simular matriculación (.csv)',
      'enrollment-button': 'Ejecutar matriculación',
      'enrollment-modal-question':
        '¿Está seguro que desea realizar la matriculación para el producto <strong>{{productCode}}</strong>? Esta acción no se puede revertir.',
      language: 'Lenguaje',
      'language-placeholder': 'Seleccionar Lenguaje',
      enrollments: 'Inscripciones',
      enrollments_title: 'Inscripciones del producto ',
      enroll_users: 'Inscribir estudiante a Producto',
      user_list: 'Selecciona el/los usuarios a inscribir al producto',
      confirm_enroll: 'Inscribir',
      enrollment_error: 'Hubo un error inscribiendo al usuario, verificar si el usuario ya existe, o intenta de nuevo mas tarde',
      enrollment_requiered: 'Tienes que seleccionar al menos un estudiante',
      enrollment_success: 'Estudiantes inscritos con éxito',
      enrollment_student_data: 'Datos del estudiante',
      enrollment_product_data: 'Datos del producto',
      enrollment_not_found: '¿No encuentras el usuario?',
      enrollment_create_option: '+ Crear nuevo usuario',
      'course-edit': 'Editar Curso',
      'course-detail': 'Detalle de Curso',
    },
    sessions: {
      'list-title': 'Lista de Sesiones',
      'show-async-class': 'Ver clases asincrónicas',
      open: 'Abrir clase',
      'open-sucess': 'Clase abierta correctamente',
      'open-failed': 'Ocurrio un error al abrir la clase',
      type: 'Tipo',
      state: 'Estado',
      programmed: 'Programada para',
      sync: 'Sincronica',
      async: 'Asincronica',
      dictated: 'Dictada',
      released: 'Liberada',
      pending: 'Pendiente',
      'not-released': 'Por liberar',
      'scheduled-range': '{{- start}} a {{- end}}',
    },
    students: {
      'list-title': 'Estudiantes',
      'import-title': 'Importar desde archivo',
      'finder-place-Holder': 'Buscar nuevo estudiante',
      'profile-title': 'Datos personales',
      name: 'Nombre',
      'last-name': 'Apellido',
      birthdate: 'Fecha de Nac.',
      'job-title': 'Título laboral',
      'document-type': 'Tipo de documento',
      'document-number': 'Número de documento',
      'fiscal-id-type': 'Tipo de identificación fiscal',
      'fiscal-id-number': 'Número de identificación fiscal',
      'fiscal-title': 'Datos fiscales',
      'contact-title': 'Datos de contacto',
      email: 'Email',
      'phone-code': 'Cod. país',
      phone: 'Número de teléfono',
      country: 'Pais de residencia',
      address: 'Dirección',
      studying: 'Cursando',
      abandoned: 'Abandonado',
      approved: 'Aprobado',
      disapproved: 'Desaprobado',
      recuperatory: 'Recuperatorio',
      undefined: 'Sin estado',
      assistance: 'de asistencia',
      product: {
        title: 'Producto',
        select: 'Seleccionar producto',
        code: 'Código',
        date: 'Inscripción realizada el día',
        status_on_product: 'Estados del estudiante en el producto'
      },
      import: {
        select_title: "Selección de Archivo",
        validate_title: "Validación de datos",
        import_data_title: "Importación de datos",
        input_csv_label: "Descargar template file",
        select_file: "Seleccione un archivo CSV",
        warning: {
          title: '¡Atención!',
          description: 'Hemos identificado algunos datos que podrían requerir tu validación adicional antes de la importación. Es importante que revises estos detalles cuidadosamente para asegurarte de que la información sea precisa y completa. Puede haber discrepancias o datos faltantes que podrían afectar la integridad de la importación. Por favor, toma un momento para verificar y corregir estos datos antes de proceder con la importación.',
          student: 'Alumno',
          track: 'Track',
          lastCourse: 'Curso actual',
          newCourse: 'Curso nuevo',
          product: 'Producto',
          warningCell: {
            already_enrolled_to_subject: "El usuario ya está inscripto a la materia",
            already_in_file_user_subject: "Ya existe otra inscripción de este usuario a esta materia en este mismo csv",
            comm_enr_already_exists: "El curso ya existe",
            course_product_time_slot_mismatch: "Los horarios de la comisión del producto no coinciden",
            course_enrollments_already_exists: "El usuario ya está inscripto al curso",
            course_enr_not_active: "El curso no está activo y se reactivará",
            course_not_found: "La comisión no existe",
            direct_enrollment_to_base_track: "El track es base y no tiene lógica de matriculación automática. Se recomienda matricularlo solo al producto",
            existing_enrollment: "El usuario es recursante",
            more_than_one_prod_in_active_state: "Se encontraron más de un producto en estado activo",
            product_not_found: "El producto no existe",
            prod_enr_not_found: "La comisión del producto no existe",
            product_enr_not_active: "La matriculación del usuario en el producto no está activa y se reactivará, junto con todos sus tracks y cursos",
            track_not_found: "El track no existe",
            track_not_in_product: "El track no forma parte del producto",
            track_enr_not_active: "El track no está activo y se reactivará, junto con todos sus cursos",
            user_not_found: "El usuario no existe",
            track_enrollments_already_exists: "El usuario ya está inscrptio al track",
            product_enrollments_already_exists: "El usuario ya está inscrptio al producto",
            user_not_active: "El usuario no está activo",
            only_students_can_enroll_to_product: "Solo se pueden enrolar usuarios con rol de alumno a productos",
            host_will_enroll_on_track_courses: "Vas a Matricular un host a un Track",
            incorrect_role_input: "Rol no permitido",
            incorrect_enrollment_destination: "Relación inexistente entre el curso, track y producto especificado",
          },
          enrollmentCell: {
            existing_enrollment: "Cambio de comisión",
            enrollment_associate: "Asociación",
            enrollment: "Matriculación",
          },
        },
        complete: {
          title: '¡Todo listo!',
          description: 'Tus datos han sido enviados para importación. Nuestro sistema está trabajando en ello y se encargará de procesar la importación de manera eficiente. Ten en cuenta que, debido a que la importación se realiza de forma asincrónica para garantizar eficiencia, puede llevar un tiempo antes de que veas los resultados.',
          import_other: 'Importar otro archivo',
          dashboard: 'Ir a reporte',
        },
        success_validation: {
          title: '¡Todo se ve bien!',
          description: '<paragraph>La validación de los datos de los usuarios se ha completado con éxito. Todos los datos han sido revisados y confirmados sin ningún problema. Ahora estás listo para llevar a cabo la importación.</paragraph>',
          cancel: 'Cancelar',
          import_now: 'Importar ahora',
          stats: {
            users: 'Usuarios',
            enrollments: 'Inscripciones',
            warnings: 'Advertencias',
            errors: 'Errores'
          }
        },
        api_error: {
          title: 'Oops, estamos teniendo dificultades…',
          description: 'Lamentablemente, tuvimos problemas al intentar cargar los datos. Por favor, intente nuevamente. Si el problema persiste, contáctese con nuestro equipo de soporte.</paragraph>',
          import: 'Importar otro archivo'
        },
        error_validation: {
          title: 'Oops, algo no está del todo bien con tu archivo...',
          description: 'Lamentablemente, no podemos procesar el archivo que intentaste cargar. Parece que hay un problema con la extensión del archivo o los datos no cumplen con los requisitos necesarios para la importación de alumnos.<paragraph>Asegúrate de que estás cargando un archivo con la extensión ".csv" y que los datos están organizados en columnas separadas por comas. Además, verifica que las columnas en el archivo coinciden con los campos requeridos para la importación. Si tienes alguna duda sobre el formato correcto, por favor revisa el archivo template o ponte en contacto con nuestro equipo de soporte para obtener asistencia.</paragraph>',
          import: 'Importar otro archivo',
          download: 'descarga archivo template'
        },
        progress_validation: {
          title: 'validando datos',
          progress: '<span>{{quantity}}</span> de <span>{{total}}</span> registros'
        },
        progress_import: {
          title: 'importando datos'
        }
      }
    },
    shifts: {
      morning: 'Turno mañana',
      evening: 'Turno tarde',
      night: 'Turno noche',
      select: 'Seleccionar Turno',
    },
    allowed_students: {
      any: 'Abierta',
      scholarships: 'Cerrada',
      select: 'Seleccionar tipo',
    },
    stages: {
      modal_change_title: 'Cambio de fase en producto',
      modal_change_title_track: 'Cambio de fase en track',
      button_change_stage: 'Cambiar de fase',
      modal_confirmation_title: 'Confirmar cambio de fase en producto',
      modal_confirmation_question: '¿Está seguro que desea realizar un cambio de fase?',
      modal_confirmation_title_commission: 'Confirmar cambio de estado del curso',
      modal_confirmation_question_commission: '¿Está seguro que desea cambiar el estado?',
      create: 'Crear Etapa',

      admission: 'Admisión',
      studying: 'Cursando',
      on_waiting_list: 'En lista de espera',
      in_stand_by: 'Cursada en stand by',
      graduate: 'Graduado',
      abandoned: 'Dado de baja',
      enrolled: 'Inscripto',
      recuperatory: 'Recuperatorio',
      disapproved: 'Desaprobado',
      approved: 'Aprobado',
      admitted: 'Admitido',
      in_stand_by_admitted: 'Admitido en stand by',
      abandoned_admission: 'Dado de baja en admisión',
      abandon_request: 'Solicitud de baja',
      non_graduate: 'No Graduado',
      commission_change: 'Cambio de curso',
      standalone_exam: 'Examen Libre',
      non_attendance_studying: 'Cursando Libre',
      deadline_expired: 'Tiempo expirado',

      'comments-about-change': 'Comentarios sobre el cambio',
      select_reason: 'Seleccione motivo',
      undefined: '-',

      '1': 'Admisión',
      '2': 'Cursando',
      '3': 'En lista de espera',
      '4': 'Cursada en stand by',
      '5': 'Graduado',
      '6': 'Dado de baja',
      '7': 'Inscripto',
      '8': 'Recuperatorio',
      '9': 'Desaprobado',
      '10': 'Aprobado',
      '11': 'Admitido',
      '12': 'Admitido en stand by',
      '13': 'Dado de baja en admisión',
      '14': 'Solicitud de baja',
      '15': 'No Graduado',
      '16': 'Cambio de comisión',
      '17': 'Cursando Libre',
      '18': 'Examen Libre',
      '19': 'Tiempo expirado',

      edges: {
        abandoned_student: 'Baja alumno',
        abandoned_absent: 'Baja por inasistencia',
        abandoned_administrative: 'Baja administrativa',
        abandoned_expelled: 'Baja por expulsión',
        abandoned_change_course: 'Baja por cambio de curso',
        abandoned_manual_admission_process: 'Baja por proceso de admisión manual',
        abandoned_rejection: 'Baja por rechazo',
        abandoned_others: 'Baja alumno',
        abandoned_economic_difficulties: 'Baja por dificultades económicas',
        abandoned_sickness: 'Baja por enfermedad',
        abandoned_admission_error: 'Baja por error en admisión',
        abandoned_time_management: 'Baja por falta de tiempo',
        abandoned_platform_discrepancy: 'Baja por inconsistencias en plataformas',
        abandoned_difficult_content: 'Baja por contenido difícil',
        abandoned_easy_content: 'Baja por contenido fácil',
        abandoned_timeframe_changed_without_warn: 'Baja por cambio de franja horaria propuesta',
        abandoned_assignments_time_changed_littl:
          'Baja por poca anticipación de cambios de horarios por bimestre',
        abandoned_scholarship_absent: 'Baja beca (Por inasistencia)',
        abandoned_scholarship_bad_performance: 'Baja beca (Por materias / cursos recursadas)',
        admission_manual_decision: 'Alta por error en admisión',
        abandoned_charge_error: 'Baja por error de carga',
        abandoned_change_semester: 'Baja por cambio de semestre',
        abandoned_personal_motives: 'Baja por motivos personales',
        abandoned_work_motives: 'Baja por motivos laborales',
        exam_absent: 'Ausente al examen',
        exam_failing_grade: 'Calificación insuficiente',
        abandoned_exam_retakes_limit_reached: 'Límite de intentos de recursadas',
        failing_attendance: 'Asistencia insuficiente',
        abandoned_course_modality: 'Baja por modalidad del curso',
        abandoned_expectation_mismatch: 'Baja por expectativas no cumplidas',
        abandoned_achieved_objectives: 'Objetivos cumplidos',
        abandoned_payment_default: 'Baja por mora',
        abandoned_pause_requested: 'Baja por solicitud de pausa',
        abandoned_unknwon: 'Desconocido',
      },
      'state-change-success': 'El estado se actualizó exitosamente.',
      'no-stages-available': 'No existen más estados posibles para esta comisión.',
    },
    courses: {
      'list-title': 'Cursos',
      select: 'Seleccionar curso',
      create: 'Crear curso',
      created: 'Curso creada',
      'schedule-tooltip': 'Calendarizar',
      scheduled: 'Curso calendarizado',
      'scheduled-error': 'Ocurrio un error al calendarizar el curso',
      edit: 'Editar Curso',
      edited: 'Curso editada',
      'detail-course': 'Detalle',
      'career-courses': 'Cursos de la carrera',
      'product-courses': 'Cursos del producto',
      dayselector: {
        title: 'Días de cursada',
        button: 'Agregar días',
        modal: 'Agregar días de cursada',
      },
      detail: {
        'start-day': 'Inicia el día',
        'end-day': 'Finaliza el día',
        'days-time': 'Días y horarios',
        calendarize: 'Calendarizar',
        recalendarize: 'Recalendarizar',
        'end-courses': 'Finalizar curso',
        'close-courses': 'Cerrar curso',
      },
      enrollments: {
        list_title: 'Inscripciones a cursos',
      },
      modal_change_title: 'Cambio de estado de curso',
      studying: 'Cursando',
      approved: 'Aprobada',
      'approved-plural': 'Aprobadas',
      'disapproved-plural': 'Desaprobadas',
      disapproved: 'Desaprobada',
      'abandoned-plural': 'Abandonadas',
      abandoned: 'Abandonada',
      versionwarning: 'Solo se visualizan aquellas versiones que se encuentran activas.',
      code: 'Código Comisión',
      course_type: 'Tipo de curso',
      course_type_error: 'Ocurrió un error al obtener el listado de tipos de curso.'
    },
    subjects: {
      'list-title': 'Materias / Cursos',
      create: 'Crear Materia / Curso',
      created: 'Materia / Curso creado',
      edit: 'Editar Materia / Curso',
      edited: 'Materia / Curso Actualizado',
      'description-placeholder': 'Describe la materia / curso',
      plan: 'Planificación de clases',
      'select-classification': 'Seleccionar clasificación',
      'select-requirements': 'Seleccionar requisitos',
      select: 'Seleccionar materia / curso',
      sort: 'Guardar orden',
      'sort-lessons-success': 'Se guardó el orden de las clases correctamente',
      'sort-modules-success': 'Se guardó el orden de los módulos correctamente',
      'sort-lessons-error': 'Ocurrio un error al guardar el orden de las clases',
      'sort-modules-error': 'Ocurrio un error al guardar el orden de los módulos',
      info: 'Información de la materia / curso',
      errors: {
        'duplicate-subject-name': 'Ya existe una materia con ese nombre',
      }
    },
    subjectVersions: {
      title: 'Versiones',
      'list-title': 'Versiones de materia',
      active: 'Activo',
      inactive: 'Inactivo',
      select: 'Seleccionar versión',
      'disable-version-title': 'Desactivar versión',
      'disable-version-error-title': 'No es posible desactivar esta versión',
      'disable-version-message':
        'Esto impedirá que se creen comisiones con esta versión mientras se mantenga inactiva ¿Está seguro que desea desactivar está versión?',
      'disable-version-error-message':
        'Está versión no puede desactivarse porque tiene comisiones relacionadas en curso.',
      info: 'Información de la versión',
      'edit-form-PG': 'Sólo visible y editable en Playground',
      edit: 'Editar versión',
      create: 'Crear versión',
      'description-placeholder': 'Describe la versión de materia',
      'create-success-message': 'Versión de materia creada exitosamente.',
      'create-error-message': 'No se pudo crear la Versión de materia.',
      'edit-success-message': 'Versión de materia editada exitosamente.',
      'edit-error-message': 'No se pudo editar la Versión de materia.',
      language: 'Lenguaje',
      'language-placeholder': 'Seleccionar Lenguaje',
      alias: 'Alias',
      'alias-hint': 'Nombre que la versión tendrá en Playground',
      'content': 'Contenido',
      'course-type': 'Tipo de curso',
      'course-type-placeholder': 'Seleccionar un tipo',
      'playground-course': 'Curso de Playground',
      'playground-course-placeholder': 'Seleccionar un curso'
    },
    timezone: {
      title: 'Zona horaria',
      select: 'Seleccionar zona horaria'
    },
    paths: {
      'title': 'Track',
      'title-create': 'Crear Track',
      section: 'Sección',
      new: 'Agregar sección',
      'create-success': 'Track creado con exito',
      'create-error': 'Ocurrio un error al intentar crear el track',
    },
    interactions: {
      'interactions-registry': 'Registro de interacciones',
      'create-label': 'Crear interacción',
      'new-label': 'Nueva interacción',
      'write-here-label': 'Escribe aquí el detalle',
      'error-msg-create-note': 'La nota de la interacción no debe superar los 4000 caracteres.',
      'success-msg-create-note': '¡La interacción fue creada exitosamente!',
      'empty-list-msg': 'No hay interacciones disponibles por el momento.',
    },
    published: {
      dialog: {
        title: 'Publicar producto',
        message: '<block>Está por publicar el producto <bold>{{code}}</bold>.</block><block>Esta acción hará que el producto se muestre en la venta online.</block><break/><block>¿Está seguro de realizar esta acción?</block>',
      },
    },
    unpublished: {
      dialog: {
        title: 'Despublicar producto',
        message: '<block>Está por despublicar el producto <bold>{{code}}</bold>.</block><block>Esta acción hará que el producto deje de mostrarse en la venta online.</block><break/><block>¿Está seguro de realizar esta acción?</block>',
      },
    },
  },
  static: {
    tracks: 'Tracks',
    order: 'Orden',
    enrollmentDate: 'Fecha de inscripción',
    keepEnrollment: 'Mantener matriculación a curso en Playground',
    isPlaygroundEnrollment: 'Matriculado en Playground',
    noPlaygroundEnrollment: 'No Matriculado en Playground',
    products: 'Productos',
    durationHours: "Duración en horas",
    isFree: "¿Es gratis?",
    coverUrl: {
      label: 'Video de portada',
      hint: 'Asegúrate de que la URL sea de un video.',
    },
    modality: {
      label: "Modalidad",
      placeholder: "Selecciona una modalidad",
    },
    category: {
      label: "Categoría",
      placeholder: "Selecciona una categoría",
    },
    technology: {
      label: "Tecnología",
      placeholder: "Selecciona una tecnología",
    },
    level: {
      label: "Dificultad",
      placeholder: "Selecciona una dificultad",
    },
    theme: {
      label: 'Tema',
      placeholder: 'Selecciona un tema',
    },
    icon: {
      label: 'Ícono',
      placeholder: 'Selecciona un ícono',
    },
    businessUnits: {
      career: 'Carrera',
      course: 'Curso intensivo',
      in_company: 'In Company',
      inCompany: 'In Company',
      financial: 'Financial',
      on_demand: 'On Demand',
      onDemand: 'On Demand',
    },
    actual: 'actual',
    profile: 'Perfil',
    'none-selected': 'Ninguno seleccionado',
    'check-in': 'Inscripción',
    subjects: 'Materias / Cursos',
    state: 'Estado',
    actions: 'Acciones',
    country: 'País',
    type: 'Tipo',
    module: 'Módulo',
    code: 'Código',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    accept: 'Aceptar',
    open: 'Abrir',
    edit: 'Editar',
    action: 'Acciones',
    classification: 'Clasificación',
    exceptionsGroups: 'Feriados',
    dateFormat: 'DD/MM/YYYY',
    timeFormat: 'HH:mm',
    careers: 'Carreras',
    change_state: 'Cambiar de estado',
    import: 'Importar desde archivo',
    dateTimeFormat: 'DD/MM/YYYY HH:mm',
    doc: 'Documento',
    doc_type: 'Tipo Doc.',
    date_time_utc: 'Día y horario UTC',
    'days-title': 'Días',
    days: {
      0: 'Domingo',
      1: 'Lunes',
      2: 'Martes',
      3: 'Miercoles',
      4: 'Jueves',
      5: 'Viernes',
      6: 'Sabado',
      L: 'L',
      M: 'M',
      X: 'X',
      J: 'J',
      V: 'V',
      S: 'S',
      D: 'D',
    },
    'days-of-study': 'Días de cursada',
    description: 'Descripción',
    'description-optional': 'Descripción (opcional)',
    'description-mandatory': 'Descripción (obligatoria)',
    duration: 'Duración',
    email: 'Email',
    date: 'Fecha',
    endDate: 'Fecha de fin',
    endTime: 'Hora de fin',
    end_date: 'Fin',
    filter: 'Filtrar',
    id: 'Id',
    initial_date: 'Inicio',
    inscription: 'Inscripción',
    'inscription-plural': 'Inscripciones',
    interaction: 'Interacción',
    'interaction-plural': 'Interacciones',
    job: 'Trabajo',
    lesson: 'Clase',
    lessons: 'Clases',
    'lessons-list': 'Clases',
    'msg-error': '¡Ups! Parece que hubo un error.',
    'msg-loading': '¡Un momento porfavor! Estamos procesando tu pedido.',
    'msg-required': 'Es necesario contestar todos los campos requeridos',
    'msg-success': '¡Felicitaciones! Salio todo bien.',
    'msg-warning': 'Cuidado! Parece que faltaron algunos datos.',
    name: 'Nombre',
    name_of_course: 'Nombre del curso',
    periodicity: 'Periodicidad',
    phone: 'Teléfono',
    requirements: 'Requisitos',
    save: 'Guardar',
    shift: 'Turno',
    startDate: 'Fecha de inicio',
    startTime: 'Hora de inicio',
    subject: 'Materia / Curso',
    subject_course: 'Curso',
    course: 'Curso',
    openDate: 'Fecha de apertura',
    surname: 'Apellido',
    select: 'Seleccione',
    vacancy: 'Vacantes',
    validators: {
      isNumber: 'El campo debe ser un numero',
      required: 'El campo es requerido',
      urlRequired: 'Ingresa una URL válida',
      min: 'Debe contener al menos {{num}} caracteres',
      regex: '{{message}}',
      'version-mismatch': 'La version debe tener el formato v.MMYYYY',
      itsBiggerThan: 'El campo {{field1}} no puede ser mayor a {{field2}}',
      email: 'El campo debe ser un email valido',
      maxCharsAndSpace: 'Debe contener máximo 6 caracteres alfanuméricos y sin espacios',
      invalidSlug: 'El campo debe contener solo letras, números y guiones',
    },
    version: 'Versión',
    staff: {
      1: 'Estudiante',
      2: 'Titular',
      3: 'Ayudante',
      4: 'Mentor',
      5: 'Host',
    },
    'staff-optional': 'Staff (opcional)',
    sessions: 'Sesiones',
    create: 'Crear',
    nonrequired: 'Campo no requerido',
    'save-changes': 'Guardar cambios',
    'order-symbol': 'º',
    alias: 'Alias',
    aliasHint: 'Es el nombre que tendrá el curso en Playground para el estudiante',
    catalogVisibility: {
      label: 'Mostrar en explorar',
      placeholder: 'Seleccione una opción',
      options: {
        true: 'Si',
        false: 'No',
      },
      hint: 'Si seleccionas esta opción, el curso sera visible en la sección explorar',
    },
    slug: 'Slug',
    slugDescription: 'Debe contener menos de 100 caracteres',
    slugHint: 'Es la parte de la URL que identifica de manera única a este curso. Debe contener menos de 100 caracteres',
    keywords: 'Keywords',
    tags: 'Etiquetas',
    tagsHint: 'Use ENTER para agregar un nuevo valor',
    bu: 'bu',
    cluster: 'Cluster',
    occupancy: 'Ocupación',
    active: 'Activo',
    'active-plural': 'Activos',
    'inactive-plural': 'Inactivos',
    cohort: 'Camada',
    'select-state': 'Seleccionar estado',
    'select-stage': 'Seleccionar fase',
    'select-change-state-reason': 'Establecer motivo del cambio',
    businessUnit: 'Unidad de Negocio',
    'select-businessUnit': 'Seleccionar Unidad de Negocio',
    'course-type': 'Tipo de Curso',
    'select-course-type': 'Seleccionar Tipo de Curso',
    'full-name': 'Nombre y apellido',
    'students-label': 'Estudiantes',
    'staff-label': 'Staff',
    'staff-students-label': 'Staff y estudiantes',
    'error-msg-generic': 'Ocurrió un error. Intentá nuevamente más tarde.',
    loading: 'Cargando',
    'time-zone': 'Franja horaria',
    apply: 'Aplicar',
    new: 'Nuevo',
    exist: 'existe',
    published: 'Publicado',
    yes: 'Sí',
    no: 'No',
    filters: 'Filtros',
    track_stages: 'Estados de track',
    productStage: 'Estado de producto',
    enroll: 'Matricular',
    allowed_students: 'Tipo',
    showing: 'Mostrando <strong>{{start}}</strong> al <strong>{{end}}</strong> de <strong>{{total}}</strong> resultados',
    next: 'Siguiente',
    previous: 'Anterior',
    product_type: 'Tipo de Producto',
    courses: 'Cursos',
    coursesWithoutProduct: 'Estos cursos no están vinculados a ningún producto específico.',
    tracksWithoutProduct: 'Estos tracks no están vinculados a ningún producto específico.',
    role: 'Rol',
  },
  errors: {
    'email-in-use': 'Esta cuenta ya está vinculada con otro usuario',
    'wrong-identification-number': 'Debe ingresar un número válido',
  },
  language: {
    spanish: 'Español',
    portuguese: 'Portugués',
    english: 'Inglés',
  },
};
